import {
    GetUsersResponse,
    OfficeSpaceBookingListResponse,
    OfficeSpaceListResponse,
} from '../../../api/types';

export function mapBookingsToListData(data: OfficeSpaceBookingListResponse['data']) {
    return data.map((item) => ({
        bookingId: item.bookingId,
        startDate: item.startDate,
        endDate: item.endDate,
        user: {
            firstName: item.user.name,
            lastName: item.user.surname,
        },
        displayName: item.space.name,
    }));
}

export function mapUsersToSelectData(data: GetUsersResponse['data']) {
    return data.map((item) => ({
        label: `${item.name} ${item.surname}`,
        value: item.id,
    }));
}

export function mapOfficeSpacesToSelectData(data: OfficeSpaceListResponse['data']) {
    const filteredData = data.filter((item) => /^\d+$/.test(item.name));

    const sortedData = [...filteredData].sort((a, b) => {
        return parseInt(a.name, 10) - parseInt(b.name, 10);
    });

    return sortedData.map((item) => ({
        label: String(item.name),
        value: String(item.name),
    }));
}

export function mapBookingsToUsersSelect(data: OfficeSpaceBookingListResponse['data']) {
    const uniqueUsers = new Map();

    data.forEach((booking) => {
        const user = booking.user;
        if (!uniqueUsers.has(user.id)) {
            uniqueUsers.set(user.id, {
                label: `${user.name} ${user.surname}`,
                value: user.id,
            });
        }
    });

    return Array.from(uniqueUsers.values());
}
